export const localTheme = {
  primary: process.env.REACT_APP_NAME === "abroadly" ? "#0095FF" : "#D94042",
};

console.log(process.env);
